import Report from "components/Report";

function CoureseReports() {
  return <Report type="course" />;
}

export default CoureseReports;
